import { css } from '@inter-ikea-kompis/web-component';
/**
 * A class with style.
 */
export default class FakeDataStyle {
    /**
     * Returns styles.
     *
     * @param options Options object.
     * @param options.theme Theme.
     * @returns Styles.
     */
    static getStyle(options) {
        const { spacing } = options.theme;
        return css `
			.container {
				max-width: ${450 / 16}rem;
			}
			.searchWrapper {
				display: flex;
				align-items: center;
			}
			.getProductButton {
				margin-left: ${spacing.space50 / 16}rem;
			}
			.checkboxes,
			.invalidateButton,
			.applyButton,
			.changedProducts,
			.dateInputs,
			.priceInputs {
				margin-top: ${spacing.space75 / 16}rem;
			}
			.loadButton {
				margin-top: ${spacing.space200 / 16}rem;
			}
		`;
    }
}
//# sourceMappingURL=FakeDataStyle.js.map